import { render } from "./Cyber.vue?vue&type=template&id=cb401ffa"
const script = {}

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__